require('./insurancesStatusWaffer.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ helpers
const { formatText } = require('core/i18n').i18n;

//@components
const ProductBannerHeader = require('components/commons/productBannerHeader/productBannerHeader');

class InsurancesStatusWaffer extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const insuranceWaferSubTitle = formatText('insuranceLanding-insuranceOfferProcessMainText');
        const insuranceWaferIcon = 'icon-house-rebrand';
        const insuranceWaferSecondaryText = [
            {
                text: formatText('insuranceLanding-insuranceOfferProcessSecondaryText', [this.props.days])
            }
        ];

        const insuranceWaferTitle = {
            icon: 'icon-insurances-badge',
            text: formatText('insuranceLanding-insuranceOfferProcessTitle')
        };

        const insuranceWaferContinueButton = {
            text: formatText('insuranceLanding-insuranceOfferProcessContinueLink'),
            isOKButton: true,
            callback: () => {
                this.props.onContinue()
            }
        };

        const insuranceWaferCustomButton = {
            confirmation: true,
            onAccept: () => {
                this.props.onCancel()
            },
            text: formatText('insuranceLanding-insuranceOfferProcessCancelLink')
        };

        return (
            <div
                ref={this.props.innerRef}
                className="insurances-status-waffer__container"
            >
                <ProductBannerHeader
                    title={insuranceWaferTitle}
                    image={insuranceWaferIcon}
                    subtitle={insuranceWaferSubTitle}
                    messages={insuranceWaferSecondaryText}
                    button={insuranceWaferContinueButton}
                    customButton={insuranceWaferCustomButton} />
            </div>
        )
    }
}

InsurancesStatusWaffer.propTypes = {
    days: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    innerRef: PropTypes.any
};

InsurancesStatusWaffer.defaultProps = {
    innerRef: () => { }
}

module.exports = InsurancesStatusWaffer;
